import React, { ReactNode } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { IFlatCorporateEvent } from '../../../../interfaces/corporateEvent';
import CorporateEventCard from '../../../../components/pages-components/b2b/corporate-events/corporate-event-card/CorporateEventCard';
import NoData from '../../../../components/reusable-components/no-data/NoData';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS, ROUTE_QUERY_CONSTANTS } from '../../../../routes';
import './mobileCorporateEvents.scss';

export interface MobileCorporateEventsProps {
  type: ROUTE_QUERY_CONSTANTS;
  corporateEventsList: IFlatCorporateEvent[];
  toolbar: ReactNode;
  isLoading?: boolean;
  message?: string; 
}

const MobileCorporateEvents = ({
  type,
  corporateEventsList,
  toolbar,
  isLoading,
  message,
}: MobileCorporateEventsProps) => {
  const navigate = useNavigate();

  return (
    <Box className="mobileCorporateEventsListContainer">
      {toolbar}
      <Box className="mobileCorporateEventsListBody">
        {isLoading ? (
          <Box className="mobileCorporateEventsListLoaderContainer">
            <CircularProgress size={24} className="mobileCorporateEventsListLoader" />
          </Box>
        ) : (
          <>
            {corporateEventsList.length > 0 ? (
              corporateEventsList.map((corporateEvent) => (
                <CorporateEventCard
                  key={corporateEvent.id}
                  type={type}
                  corporateEvent={corporateEvent}
                  onClick={() => {
                    navigate(
                      `${ROUTE_PATHS.B2B.EVENT_DETAIL.replace(
                        ':id',
                        corporateEvent?.id as string
                      )}?type=${type}`
                    );
                  }}
                />
              ))
            ) : (
              <NoData className="mobileCorporateEventsListNoData" message={message || "No corporate events found"} />
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default MobileCorporateEvents;
